var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import { SgdfElement } from '../../internal/sgdf-element.js';
import styles from './comment-tag-picker.styles.js';
/**
 * @summary Tag picker.
 *
 */
class SgdfCommentTagPicker extends SgdfElement {
    constructor() {
        super(...arguments);
        this.selectedTags = [];
    }
    connectedCallback() {
        super.connectedCallback();
        this.getTag = this.getTag.bind(this);
    }
    handleInput() {
        this.selectedTags = this.commentTags.filter((tag) => { var _a; return (_a = this.tagInput) === null || _a === void 0 ? void 0 : _a.value.includes(tag.id); });
    }
    getTag(option) {
        const tag = this.commentTags.find((tag) => tag.id === option.value);
        if (!tag) {
            return html ``;
        }
        return html `
            <sl-tag removable>
                ${when(tag.icon, () => html `
                        <sgdf-icon
                            name=${tag.icon}
                            style="padding-inline-end: .5rem;"
                        ></sgdf-icon>
                    `)}
                ${tag.label}
            </sl-tag>
        `;
    }
    render() {
        var _a;
        const noTags = this.commentTags.length === 0;
        return html `<sl-select
            .getTag=${this.getTag}
            .placeholder=${noTags ? 'Aucune étiquette' : 'Etiquette'}
            class="comment-tag-select custom-tag"
            name="tags_id"
            id="tags_id"
            value=${(_a = this.selectedTags
            .map((tag) => tag.id)) === null || _a === void 0 ? void 0 : _a.join(' ')}
            @sl-input=${this.handleInput}
            multiple
            clearable
            ?disabled=${noTags}
        >
            ${this.commentTags.map((tag) => html `<sl-option value=${tag.id}>
                        ${when(tag.icon, () => html `
                                <sgdf-icon
                                    size="small"
                                    slot="prefix"
                                    name=${tag.icon}
                                ></sgdf-icon>
                            `)}
                        ${tag.label}
                    </sl-option>`)}
        </sl-select>`;
    }
}
SgdfCommentTagPicker.styles = styles;
export default SgdfCommentTagPicker;
__decorate([
    property({ type: Array, reflect: true })
], SgdfCommentTagPicker.prototype, "selectedTags", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfCommentTagPicker.prototype, "commentTags", void 0);
__decorate([
    query('.comment-tag-select')
], SgdfCommentTagPicker.prototype, "tagInput", void 0);
//# sourceMappingURL=comment-tag-picker.component.js.map